/**
 * Global Privacy Control (globalprivacycontrol.org) is a browser/extension
 * signal that communicates a user's opt-out preference (e.g. "Do Not Sell or
 * Share My Personal Information" under the CCPA/CPRA) without requiring them
 * to interact with a site's own cookie banner.
 */

/** Returns true if the browser is sending a Global Privacy Control signal. */
export function hasGlobalPrivacyControl(): boolean {
  if (typeof navigator === "undefined") return false;
  return (
    (navigator as { globalPrivacyControl?: boolean }).globalPrivacyControl ===
    true
  );
}

/**
 * Decides whether the analytics cookie category should be enabled by default
 * (before the user has made an explicit choice). GPC is treated as an
 * immediate, standing opt-out request.
 */
export function shouldEnableAnalyticsByDefault(gpcSignal: boolean): boolean {
  return !gpcSignal;
}
